/**
 * ajax请求配置
 */
import axios from 'axios'
import NProgress from 'nprogress'
import {serverUrl, url} from "./globalVar"
//import Qs from 'qs'

// import cookie from '../../static/js/cookie.js'

// axios默认配置
// axios.defaults.timeout = 60000;   // 超时时间
axios.defaults.baseURL = serverUrl;  // 默认地址

//整理数据
axios.defaults.transformRequest = function (data) {
//data = Qs.stringify(data);
    data = JSON.stringify(data);
    return data;
};

axios.interceptors.request.use(
    config => {
        // //config.data = JSON.stringify(config.data);
        let token = sessionStorage.getItem("authorization");
        if (token) {
            config.headers['Authorization'] = token;
        }
        if(!config.headers['Content-Type']){
            config.headers['Content-Type'] = 'application/json;charset=UTF-8';
        }

        // //判断是否存在ticket，如果存在的话，则每个http header都加上ticket
        // if (cookie.get("token")) {
        //     //用户每次操作，都将cookie设置成2小时
        //     config.headers.token = cookie.get("token");
        //     config.headers.name= cookie.get("name");
        // }
        NProgress.start();
        return config;
    },
    error => {
        NProgress.done();
        return Promise.reject(error.response);
    });

// 创建一个处理401错误的函数
function handle401Error() {
    console.log('Handling 401 error - Token expired');

    // 清除本地存储的token
    sessionStorage.removeItem("authorization");
    sessionStorage.removeItem("user");
    localStorage.removeItem("authorization");

    // 重置路由标记
    if (window.addRouFlag !== undefined) {
        window.addRouFlag = false;
    }

    // 显示提示信息
    if (window.Vue && window.Vue.prototype.$message) {
        window.Vue.prototype.$message.error('登录已过期，请重新登录');
    }

    // 延迟重定向，确保用户能看到提示
    setTimeout(() => {
        console.log('Redirecting to login page:', url + "/");
        window.location.href = url + "/";
    }, 500);
}

// 路由响应拦截
// http response 拦截器
axios.interceptors.response.use(
    response => {
        NProgress.done();

        // 检查响应数据中的状态码（后端自定义状态码）
        if (response.data && response.data.status === 401) {
            console.log('Detected 401 in response data, handling...');
            handle401Error();
            return Promise.reject(new Error('Token expired'));
        }
        return response;
    },
    error => {
        NProgress.done();
        // console.log('Axios Response Interceptor - Error:', error);
        // console.log('Error Response:', error.response);
        // console.log('Error Status:', error.response ? error.response.status : 'No response');

        // 检查HTTP状态码
        if (error.response && error.response.status === 401) {
            console.log('Detected HTTP 401, handling...');
            handle401Error();
            return Promise.reject(new Error('Token expired'));
        }

        // 作为备用方案，检查是否包含401相关的错误信息
        if (error.message && error.message.includes('401')) {
            console.log('Detected 401 in error message, handling...');
            handle401Error();
            return Promise.reject(new Error('Token expired'));
        }
        return Promise.reject(error)   // 返回接口返回的错误信息
    });
export default axios;


// WEBPACK FOOTER //
// ./src/axios-init.js